module.exports = __webpack_public_path__ + "img/L-basic.b519ff4d.svg";